export default __webpack_public_path__ + "static/media/alamo-site.36a9b3b3.webp";